"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  "use strict";

  var moduleName = "damages.informManager";
  var componentName = "informManager";

  var bindings = {
    resolve: "<?",
    damage: "<?"
  };

  var templateUrl = "app/pages/damages/informManager/informManager.html";

  var Controller = function () {
    /** @ngInject */
    function Controller($rootScope, $scope, $timeout, $window, UsersService, ModalService) {
      _classCallCheck(this, Controller);

      this.log = debug("pages:damages:informManager");

      this.log(moduleName + "/" + componentName);

      this.$rootScope = $rootScope;
      this.$scope = $scope;
      this.$timeout = $timeout;
      this.$window = $window;
      this.UsersService = UsersService;
      this.ModalService = ModalService;
    }

    _createClass(Controller, [{
      key: "save",
      value: function save() {
        this.log("selectManager", this.selectManager);
        this.close(this.selectManager);
      }
    }, {
      key: "refresh",
      value: function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var positions;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return this.UsersService.getPositionArray(this.$rootScope.$selectedCustomerId);

                case 2:
                  positions = _context.sent;
                  _context.next = 5;
                  return this.UsersService.remoteSelectArray(positions.map(function (position) {
                    if (position.value != "Conducteur") {
                      return position.value;
                    }
                  }));

                case 5:
                  this.managers = _context.sent;

                case 6:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function refresh() {
          return _ref.apply(this, arguments);
        }

        return refresh;
      }()
    }, {
      key: "edit",
      value: function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return this.ModalService.open("users/user", {
                    _id: this.selectManager.replace("$", "")
                  });

                case 2:
                  _context2.next = 4;
                  return this.refresh();

                case 4:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        function edit() {
          return _ref2.apply(this, arguments);
        }

        return edit;
      }()
    }, {
      key: "create",
      value: function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return this.ModalService.open("users/user", {
                    position: "Manageur"
                  });

                case 2:
                  _context3.next = 4;
                  return this.refresh();

                case 4:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, this);
        }));

        function create() {
          return _ref3.apply(this, arguments);
        }

        return create;
      }()
    }, {
      key: "close",
      value: function close(managerId) {
        this.log("$scope", this.$scope);
        if (this.$scope.$parent) {
          this.$scope.$parent.$close(managerId);
        }
      }
    }, {
      key: "$onInit",
      value: function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
          var isAdmin, isSuper, onlyUnique;
          return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  isAdmin = ["super-admin", "user-admin"].indexOf(this.$rootScope.$user.role) > -1 ? true : false;
                  isSuper = ["super-admin", "super-operator"].indexOf(this.$rootScope.$user.role) > -1 ? true : false;

                  this.writeResource = isAdmin || this.$rootScope.$user.rights && this.$rootScope.$user.rights.resource && this.$rootScope.$user.rights.resource.write && this.$rootScope.$user.rights.resource.write === true;

                  _context4.next = 5;
                  return this.refresh();

                case 5:

                  this.damage = this.resolve.params.damage;
                  this.emails = [];
                  if (this.damage.informManager && this.damage.informManager.emails) {
                    onlyUnique = function onlyUnique(value, index, array) {
                      return array.indexOf(value) === index;
                    };

                    this.emails = this.damage.informManager.emails.split(",").filter(onlyUnique);
                  }
                  this.$timeout(function () {}, 0);

                case 9:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, this);
        }));

        function $onInit() {
          return _ref4.apply(this, arguments);
        }

        return $onInit;
      }()
    }]);

    return Controller;
  }();

  angular.module(moduleName).component(componentName, {
    templateUrl: templateUrl,
    bindings: bindings,
    //transclude: true,
    controller: Controller
  });
})();